'use client';

import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

const merge = (base: SxProps<Theme>, extra?: SxProps<Theme>): SxProps<Theme> =>
    extra ? [base, ...(Array.isArray(extra) ? extra : [extra])] : base;

export function GuideEyebrow({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) {
    return (
        <Typography
            sx={merge(
                {
                    color: 'var(--accent)',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    mb: 1,
                },
                sx
            )}
        >
            {children}
        </Typography>
    );
}

export function GuideTitle({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) {
    return (
        <Typography
            variant="h1"
            sx={merge(
                {
                    fontSize: { xs: '1.75rem', md: '2.25rem' },
                    fontWeight: 700,
                    letterSpacing: '-0.02em',
                    lineHeight: 1.15,
                    color: 'var(--fg)',
                    mb: 1.5,
                },
                sx
            )}
        >
            {children}
        </Typography>
    );
}

export function GuideSubtitle({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) {
    return (
        <Typography
            sx={merge(
                {
                    fontSize: { xs: '1rem', md: '1.0625rem' },
                    lineHeight: 1.6,
                    color: 'var(--fg-muted)',
                    maxWidth: '68ch',
                    mb: 5,
                },
                sx
            )}
        >
            {children}
        </Typography>
    );
}

export function GuideSection({ children }: { children: ReactNode }) {
    return (
        <Typography
            variant="h2"
            sx={{
                fontSize: { xs: '1.25rem', md: '1.5rem' },
                fontWeight: 700,
                letterSpacing: '-0.01em',
                color: 'var(--fg)',
                mt: 5,
                mb: 1.5,
            }}
        >
            {children}
        </Typography>
    );
}

